import { Offcanvas, Collapse, Container, Row, Col } from 'react-bootstrap';
import { ShopStyled } from '../shopSetting/assets/shopStyled';
import styled from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import StyledText from '../../app/components/styledComponents/StyledText';
import StyledInputWithIcon from '../../app/components/styledComponents/StyledInputWithIcon';
import DropDownIcon from '../../app/components/svgIcons/DropDownIcon';
import { closeHelpSection } from '../../app/services/helpSectionSlice';
import { HELPSECTIONTOPICS } from '../../utils/Constants';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const helpSectionTopicsList = [
  {
    title: 'Contact Us',
    selector: HELPSECTIONTOPICS.CONTACTUS,
    renderHtml: () => (
      <Container>
        <Row className="g-3 ">
          <Col xs={12} className="divider">
            <StyledText $fontSize="18px" $fontWeight="400" color="bodyMedium">
              (888) 575-3858
            </StyledText>
            <div className="mt-3">
              <StyledText
                $fontSize="18px"
                $fontWeight="400"
                href="mailto:sales@boostfloral.com"
                className="text-decoration-underline"
                as="a"
              >
                sales@boostfloral.com
              </StyledText>
              <StyledText $fontSize="18px" $fontWeight="400" color="bodyMedium">
                For questions about subscriptions
              </StyledText>
            </div>
            <div className="mt-3">
              <StyledText
                $fontSize="18px"
                $fontWeight="400"
                href="mailto:support@boostfloral.com"
                className="text-decoration-underline"
                as="a"
              >
                support@boostfloral.com
              </StyledText>
              <StyledText $fontSize="18px" $fontWeight="400" color="bodyMedium">
                For help setting up your website
              </StyledText>
            </div>
            <div className="mt-3">
              <StyledText
                $fontSize="18px"
                $fontWeight="400"
                href="mailto:info@boostfloral.com"
                className="text-decoration-underline"
                as="a"
              >
                info@boostfloral.com
              </StyledText>
              <StyledText $fontSize="18px" $fontWeight="400" color="bodyMedium">
                For general inquires, partnering details,
                <br />
                or web design consulting
              </StyledText>
            </div>
          </Col>
        </Row>
      </Container>
    ),
  },
  {
    title: 'Adding a Gallery Section',
    selector: HELPSECTIONTOPICS.GALLERYSECTION,
    videoUrl:
      'https://www.loom.com/embed/b580610268cf4084a119b90e3d02e6b5?sid=99319e77-25b4-442b-ab24-7f1fe487b04',
  },
  {
    title: 'Adding Tags to Products and Sections',
    selector: HELPSECTIONTOPICS.ADDPRODUCTTAGS,
    videoUrl:
      'https://www.loom.com/embed/e9d2f5fffab749139fea60220e08beaa?sid=1f3a2547-b57d-4053-aaf6-db9c90ed6c59',
  },
  {
    title: 'Adding a Tag Filter to Features Categories',
    selector: HELPSECTIONTOPICS.TAGFILTER,
    videoUrl:
      'https://www.loom.com/embed/25c6f014d5924e2a98776c5471e21317?sid=d0325dc5-1436-4e2b-9dca-b899c784b5ed',
  },
  {
    title: 'Brief Introduction to the Website Editor',
    selector: HELPSECTIONTOPICS.WEBSITEEDITORINTRO,
    videoUrl:
      'https://www.loom.com/embed/b779c61fc8524d93912b837a75f6e725?sid=1b532ced-ae6c-4ad8-b3c0-6e3ebdbf68a9',
  },
  {
    title: 'Configuring Black Out Dates',
    selector: HELPSECTIONTOPICS.BLACKOUTDATES,
    videoUrl:
      'https://www.loom.com/embed/c7b39a3c0fd34cdba35e1d1971f21fab?sid=c5b446bd-ae51-42f2-be39-75528cf5e4fa',
  },
  {
    title: 'Configure Ecommerce Shop Settings',
    selector: HELPSECTIONTOPICS.CONFIGURESHOPSETTINGS,
    videoUrl:
      'https://www.loom.com/embed/22c1b99fc0e8485ca70ed9ace474eabf?sid=378125ce-e817-4567-9dac-6b52c2df8f0b​',
    description:
      'Within the Shop Settings, you have the ability to set configurations such as blackout dates, tax rates, and delivery charges. These configurations need to be completed prior to publishing your live website.',
  },
  {
    title: 'Deactivate Product',
    selector: HELPSECTIONTOPICS.DEACTIVATEPRODUCT,
    videoUrl:
      'https://www.loom.com/embed/dbb4639f9949429f974816ef7342e9e9?sid=3ad3c8b3-6fe9-4482-aafc-5b9bce2374da',
    description:
      'A Product can be deactivated when you do not want it to be displayed anywhere on your website. This is useful for seasonal products that you do not want displayed year-round. This keeps you from having to delete them or add them each season.',
  },
  {
    title: 'Delivery Charges Settings',
    selector: HELPSECTIONTOPICS.DELIVERYCHARGESETTINGS,
    videoUrl:
      'https://www.loom.com/embed/dca7f702a40e496093e6fc308d41f76d?sid=caed3ca7-2d5b-4ca1-9ed8-3f337510a34d',
  },
  {
    title: 'Determine which Add-ons are associated with Products',
    selector: HELPSECTIONTOPICS.ADDONS,
    videoUrl:
      'https://www.loom.com/embed/947ba4f005ed4e2f8413647ea2cace0a?sid=c62bcab8-a3aa-4814-8c38-313185181d1c',
  },
  {
    title: 'Hide from product page',
    selector: HELPSECTIONTOPICS.HIDEFROMPRODUCTPAGE,
    videoUrl:
      'https://www.loom.com/embed/3854f38695a8436798424ce70f8d6f18?sid=bc03a96a-9782-465e-9d2f-3e61a571ca46​',
    description:
      'This setting can be applied to Products that you do not want displayed on the product page. For example, if you wanted to create specific pages for seasonal items instead of having them appear on Product page, you could use this setting.',
  },
  {
    title: 'Image Tag',
    selector: HELPSECTIONTOPICS.METASOCIALIMAGE,
    description:
      'The image tag is usually considered to be the most important because it occupies the most social feed real estate.​<ul><li>Best practices​</li><li>Use custom images for “shareable” pages(e.g., homepage, articles, etc.)</li><li>Use your logo or any other branded image for the rest of your pages.​</li><li>Use images with a 1.91: 1 ratio and minimum recommended dimensions of 1200x630 for optimal clarity across all devices.</li></ul>',
  },
  {
    title: 'Local Delivery Only',
    selector: HELPSECTIONTOPICS.LOCALDELIVERYONLY,
    videoUrl:
      'https://www.loom.com/embed/179e6888cd544af3b4ccdd866a8fdb75?sid=238b51e9-f93d-4b29-8de8-647bd823f312',
    description:
      'If a Product is configured with “Local Delivery Only,” the website will only allow website transactions to occur when the delivery zip code is included in the Zip Codes configured in Shop Settings.<br/>If “Local Delivery Only” is set to “Global,” then transactions can occur even when the delivery zip code is not included in Shop Settings zip codes, but it will be identified as a Non-Local Delivery.',
  },
  {
    title: 'Meta Description',
    selector: HELPSECTIONTOPICS.METADESCRIPTION,
    description:
      "A <strong>Meta Description</strong> serves as a concise summary displayed below the title on Search Engine Results Pages (SERPs). It's crucial for each of your pages to possess a distinct and accurate description reflecting their content. To avoid truncation in search results, <strong>aim for a meta description length between 150 and 160 characters.</strong><br /><br />However, controlling your meta description isn't always guaranteed. Despite your efforts in crafting them, search engines might override your provided information, leading to rewritten descriptions or incorrect content displayed.<br /><br />This description holds significance for both search engines and users. Crafting an impactful meta description can boost website clicks by setting clear expectations regarding the content users will find.<br /><br />Incorporating relevant keywords in the meta description aids in content discovery and informs search engines about the page's focus. It's an opportunity to communicate the page's purpose and what visitors can expect upon clicking. Additionally, conducting A/B testing on different descriptions can reveal which versions generate more clicks, aiding in higher rankings and increased website traffic. Explore effective description writing through these examples of meta descriptions.",
  },
  {
    title: 'Meta Keywords',
    selector: HELPSECTIONTOPICS.METAKEYWORDS,
    description:
      'The <strong>Meta Keyword</strong> tag serves to specify the keywords you aim to rank for. However, its relevance diminishes annually as most search engines disregard this tag. In fact, overuse or improper use of this tag could result in penalties, hindering your ability to rank for desired keywords. When appropriately utilized, this tag can signal to search engines the essential keywords within your page content.<br /><br />Notably, Google no longer utilizes the meta keyword tag, but it might still hold weight with other search engines. Hence, considering its potential impact on SEO for platforms beyond Google could be beneficial.<br /><br />At the very least, employing the meta keyword tag allows you to track the keywords targeted across various website pages.<br /><br />Given that major search engines have phased out the meta keyword tag from their ranking considerations, investing time in it becomes unnecessary. Instead, focusing on other meta tags that contribute to improved rankings and enhanced user experience would be more worthwhile.',
  },
  {
    title: 'Meta Title',
    selector: HELPSECTIONTOPICS.METATITLE,
    description:
      "<strong>Meta Title</strong> tags play a crucial role in informing search engines about a webpage's content, influencing their decision on whether to rank the page for specific search queries. These tags also aid in user navigation by displaying in browser tabs.<br /><br />Crafting effective title tags involves incorporating relevant keywords to boost search engine ranking. Yet, they must also compel users to click and engage with your content. Prioritizing key terms at the start of the title is vital due to limited space. Moreover, ensuring each page has a distinct title is essential to prevent confusion among search engines and users.",
  },
  {
    title: 'My Site',
    selector: HELPSECTIONTOPICS.MYSITE,
    videoUrl:
      'https://www.loom.com/embed/bc5779142a0e4923bc34c894a865c455?sid=4b817dda-6418-4d8a-b391-26578c093a49',
  },
  {
    title: 'Product Top Tags',
    selector: HELPSECTIONTOPICS.PRODUCTTOPTAGS,
    videoUrl:
      'https://www.loom.com/embed/bb25e6e8bc5e4b05b7a36d50ba875ddb?sid=e704eea1-7bcc-440b-80b1-2480b1ca5182',
    description:
      'BoostFloral sites use Product tags to determine where Products should be displayed. The “Top Tags” are used for special sections such as Favorites, Top Rated, or Deal of the Day items allowing you to highlight these products.<br />All Template sites have sections looking for Products with these Top Tags, so it is important to add these Tags to some of your Products.',
  },
  {
    title: 'Payout Amount',
    selector: HELPSECTIONTOPICS.PAYOUTAMOUNT,
    description:
      '<strong>Total Order Amount</strong><br />Florist Paid: (Product Amount + Delivery + Taxes = Total Order Amount)<br />Customer Paid: (Product Amount + Delivery + Taxes + Service Fee = Total Order Amount)<br /><br /><strong>Payout Amount</strong><br/>(Total Sale Amount - Service Fee = Payout Amount)',
  },
  {
    title: 'Social Media Meta Settings',
    selector: HELPSECTIONTOPICS.METASOCIALMEDIA,
    description:
      'Each webpage needs to include the fundamental social media tags: <strong>title</strong>, <strong>type</strong>, <strong>image</strong>, and <strong>URL</strong>. These tags ensure optimal display on various social media platforms such as Facebook, Twitter, LinkedIn, and others. Incorporating these four essential tags is <strong>imperative</strong>.',
  },
  {
    title: 'Updating Website Pages and Sections',
    selector: HELPSECTIONTOPICS.UPDATINGPAGESANDSECTIONS,
    videoUrl:
      'https://www.loom.com/embed/422d444fd7964c27a9c2ac107aa8e9d1?sid=1faecc27-895f-4849-a713-57b76aa69bb9',
  },
  {
    title: 'Updating the Hero banner Image on a Website',
    selector: HELPSECTIONTOPICS.HEROBANNERIMAGE,
    videoUrl:
      'https://www.loom.com/embed/29ae65f91ae645e387bf37ec3c5b491a?sid=69355ce4-95d7-4d9e-81bd-b32c49b7b66b​',
  },
];

const StyledOffCanvasBody = styled(Offcanvas.Body)`
  background-color: ${({ theme }) => theme.primaryLight2};
  overflow: initial;
`;

const filterHelpSections = (data, search) => {
  if (!search) return data;
  return data?.filter((section) => {
    const titleIncludesSearch =
      section.title?.toLowerCase()?.includes(search.toLowerCase()) ?? false;
    const descriptionIncludesSearch =
      section.description?.includes(search.toLowerCase()) ?? false;
    return titleIncludesSearch || descriptionIncludesSearch;
  });
};

const HelpSection = () => {
  const dispatch = useDispatch();
  const expandedCardRef = useRef(null);
  const [search, setSearch] = useState('');
  const [data, setData] = useState(helpSectionTopicsList);
  const { show, comingFrom } = useSelector((state) => state.helpSection);

  const onHide = () => {
    setData(helpSectionTopicsList);
    dispatch(closeHelpSection());
  };

  const handleTopicToggle = (index) => {
    setData((prevData) => {
      const deepCopy = [...prevData];
      const itemToBeUpdated = { ...deepCopy[index] };
      const updatedItem = {
        ...itemToBeUpdated,
        isOpen: !itemToBeUpdated.isOpen,
      };
      deepCopy[index] = updatedItem;
      return deepCopy;
    });
  };

  useEffect(() => {
    let scrollTimeout;
    if (comingFrom) {
      setData((prevData) => {
        const deepCopy = [...prevData];
        return deepCopy?.map((item) => {
          if (item.selector === comingFrom) {
            return { ...item, isOpen: true, initialRef: true };
          } else {
            return item;
          }
        });
      });

      scrollTimeout = setTimeout(() => {
        if (expandedCardRef.current) {
          expandedCardRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 300);
    }

    return () => clearTimeout(scrollTimeout);
  }, [comingFrom]);

  useEffect(() => {
    const result = filterHelpSections(helpSectionTopicsList, search);
    setData(result);
  }, [search]);

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement={'end'}
      style={{
        minWidth: '40vw',
      }}
    >
      <Offcanvas.Header closeButton className="bg-white px-4">
        <Offcanvas.Title>
          <ShopStyled.PageTitle className="m-0">
            Help Section
          </ShopStyled.PageTitle>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <StyledOffCanvasBody className="px-0">
        <Container className="mb-4 px-4">
          <Row>
            <Col>
              <StyledInputWithIcon
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search"
              />
            </Col>
          </Row>
        </Container>

        <Container
          className="px-4 py-2 overflow-auto"
          style={{
            height: 'calc(100vh - 150px)',
          }}
        >
          {data?.length ? (
            <>
              {data?.map((item, index) => (
                <ShopStyled.BootstrapCollapseCard
                  key={index}
                  style={{
                    boxShadow:
                      '0 0 4px 0 rgba(0, 0, 0, 0.04), 0 8px 16px 0 rgba(0, 0, 0, 0.08)',
                  }}
                  padding="0"
                  id={`section-${item.selector}`}
                  {...(item.initialRef && { ref: expandedCardRef })}
                >
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer"
                    onClick={() => handleTopicToggle(index)}
                    aria-controls={`section-section1`}
                    aria-expanded={item?.isOpen}
                  >
                    <div className=" d-flex justify-content-between align-items-center py-3 px-4 w-100">
                      <div>
                        <StyledText
                          as="h5"
                          $fontSize="20px"
                          color="heading"
                          $fontWeight="600"
                          className="m-0"
                        >
                          {item.title}
                        </StyledText>
                      </div>
                      <StyledText color="icon" className="mb-0 ">
                        <DropDownIcon rotate={`${item?.isOpen ? 'up' : ''}`} />
                      </StyledText>
                    </div>
                  </div>
                  <Collapse in={item.isOpen}>
                    <div className="border-top py-3 px-4">
                      {item?.videoUrl && (
                        <div
                          style={{
                            position: 'relative',
                            paddingBottom: '56.25%',
                            height: 0,
                          }}
                        >
                          {item.isOpen && (
                            <iframe
                              title="Loom Video"
                              src={item.videoUrl}
                              frameBorder="0"
                              allowFullScreen
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                              }}
                            />
                          )}
                        </div>
                      )}

                      {item?.description && (
                        <div className="my-2 my-md-3">
                          <StyledText
                            color={'bodyMedium'}
                            $fontSize="18px"
                            $fontWeight="400"
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                        </div>
                      )}

                      {item?.renderHtml && (
                        <div className="my-2 my-md-3">{item.renderHtml()}</div>
                      )}
                    </div>
                  </Collapse>
                </ShopStyled.BootstrapCollapseCard>
              ))}
            </>
          ) : (
            <></>
          )}
        </Container>
      </StyledOffCanvasBody>
    </Offcanvas>
  );
};

export default HelpSection;
